import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { get } from 'lodash-es';

@Component({
    imports: [FormsModule],
    selector: 'rdx-geo-file-import-upload',
    styleUrls: ['./geo-file-import-upload.component.scss'],
    templateUrl: './geo-file-import-upload.component.html',
})
export class GeoFileImportUploadComponent implements OnInit {
    @Input() errorMessage: string;
    @Input() errorMessageDetail: string;
    @Output() fileSelected = new EventEmitter<File>();
    @Output() cancelled = new EventEmitter<void>();

    isDragOver: boolean;

    constructor(
        private matDialogRef: MatDialogRef<GeoFileImportUploadComponent>
    ) {}

    ngOnInit() {
        this.initFileDrop();
    }

    onFileDragEnter() {
        this.isDragOver = true;
    }

    onFileDragLeave() {
        this.isDragOver = false;
    }

    onFileDropped(event: DragEvent) {
        this.isDragOver = false;
        const file = get(event, ['dataTransfer', 'files', 0]);
        if (!file) {
            return;
        }
        this.uploadGpx(file);
    }

    onFileSelected(fileInput: Event) {
        const file = get(fileInput, ['target', 'files', 0]) as File | undefined;
        if (!file) {
            return;
        }
        this.uploadGpx(file);
    }

    onCancel() {
        this.matDialogRef.close();
    }

    private initFileDrop() {
        const dropElement = document.querySelector('.file-drop-input');
        [
            'drag',
            'dragstart',
            'dragend',
            'dragover',
            'dragenter',
            'dragleave',
            'drop',
        ].forEach((eventName) => {
            dropElement?.addEventListener(eventName, (e) => {
                e.preventDefault();
                e.stopImmediatePropagation();
            });
        });
    }

    private uploadGpx(file: File) {
        const nameRegex = /\.(gpx)$/i;
        if (file.type !== '' || !nameRegex.test(file.name)) {
            this.errorMessage = $localize`Please select a GPX file`;
            this.errorMessageDetail = '';
            return;
        }

        this.fileSelected.emit(file);
    }
}
